import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { Spinner } from '../../../';
export const MapSpinner = props => {
    const { active } = props;
    const [visible, toggleVisibility] = useState(true);
    const [transparent, toggleTransparency] = useState(false);
    const showSpinner = () => {
        toggleVisibility(true);
        toggleTransparency(false);
    };
    const hideSpinnerWithDelay = () => {
        toggleTransparency(true);
        setTimeout(() => {
            toggleVisibility(false); // remove after delay to blur out
        }, 500);
    };
    useEffect(() => {
        if (active) {
            showSpinner();
        }
        else {
            hideSpinnerWithDelay();
        }
    }, [active]);
    return visible
        ? React.createElement("div", { className: cx('loading-box', { 'loading-box--transparent': transparent }) },
            React.createElement(Spinner, { loading: true, className: cx('map-spinner', { 'map-spinner--transparent': transparent }), size: "xl", centered: true }))
        : null;
};
//# sourceMappingURL=MapSpinner.js.map